import React from "react";
import LegalShell from "@/pages/LegalShell";

export default function Privacy() {
  return (
    <LegalShell eyebrow="LEGAL" title="Privacy Policy" updated="February 2026">
      <h2>1. What We Collect</h2>
      <ul>
        <li>
          <strong>Account data.</strong> Your email address, and (if you sign in with Google) your
          name and profile picture.
        </li>
        <li>
          <strong>Content data.</strong> Documents you draft, chat messages, project details,
          predicate/MAUDE queries, and any device information you enter.
        </li>
        <li>
          <strong>Session data.</strong> An encrypted session cookie used to keep you signed in.
        </li>
        <li>
          <strong>Standard technical data.</strong> IP address, browser type, and request
          timestamps for security and reliability.
        </li>
      </ul>

      <h2>2. How We Use It</h2>
      <ul>
        <li>To provide, maintain, and improve the Service.</li>
        <li>To save your drafts and projects so you can return to them.</li>
        <li>To send occasional product updates to your registered email (you can opt out).</li>
        <li>To respond to support requests you send us.</li>
      </ul>

      <h2>3. AI Processing</h2>
      <p>
        Prompts you submit are sent to our AI provider (currently Anthropic Claude via Emergent
        Integrations) to generate responses. We do not sell your data or use your content to
        train third-party foundation models beyond what is required to serve your request.
      </p>

      <h2>4. Public Data Sources</h2>
      <p>
        Predicate and adverse-event data are pulled from public U.S. Government APIs (openFDA and
        eCFR). Regulation freshness checks send only the regulation reference (e.g. "21 CFR 820")
        to eCFR, not your content.
      </p>

      <h2>5. Data Sharing</h2>
      <p>We do not sell your personal information. We share data only:</p>
      <ul>
        <li>With service providers (hosting, database, AI provider) under contract to us.</li>
        <li>With teammates you explicitly invite to a project.</li>
        <li>When required by law or to protect the rights, property, or safety of any person.</li>
      </ul>

      <h2>6. Data Retention</h2>
      <p>
        We retain your account and content until you request deletion. Email
        <a href="mailto:hello@qualmitta.com"> hello@qualmitta.com</a> to delete your account and
        associated data. Deletion is permanent and cannot be undone.
      </p>

      <h2>7. Security</h2>
      <p>
        We use industry-standard measures (encrypted transport, restricted access, secure
        session cookies) to protect your data. No system is 100% secure; we recommend not
        submitting highly sensitive proprietary information you would not want stored in a
        cloud service.
      </p>

      <h2>8. Your Rights</h2>
      <p>
        Depending on your jurisdiction, you may have the right to access, correct, port, or
        delete your personal data. Contact <a href="mailto:hello@qualmitta.com">hello@qualmitta.com</a>
        to exercise those rights.
      </p>

      <h2>9. Children</h2>
      <p>
        The Service is not directed to children under 18. We do not knowingly collect data from
        children.
      </p>

      <h2>10. Changes</h2>
      <p>
        We may update this Privacy Policy. Material changes will be highlighted at the top of
        this page.
      </p>

      <h2>11. Contact</h2>
      <p>
        Privacy questions? Email <a href="mailto:hello@qualmitta.com">hello@qualmitta.com</a>.
      </p>
    </LegalShell>
  );
}
